import { Component, Injectable, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { CollectionViewer, SelectionChange } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, merge, map, forkJoin } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { Router } from '@angular/router';
import { BsDatepickerConfig, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AuService } from '../qms/au/au.service';
import { AuComponent } from '../qms/au/au.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MsalService } from '@azure/msal-angular';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from 'src/app/editor/editor.component';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
export class DynamicFlatNode {

  constructor(public item: string, public parentModule: string, public subModule: string,
    public moduleCode: string, public level = 1, public expandable = false,
    public isLoading = false) {
  }
}
@Injectable()
export class DynamicDataSource {

  dataChange = new BehaviorSubject<DynamicFlatNode[]>([]);

  get data(): DynamicFlatNode[] { return this.dataChange.value; }
  set data(value: DynamicFlatNode[]) {
    this._treeControl.dataNodes = value;
    this.dataChange.next(value);
  }

  constructor(private _treeControl: FlatTreeControl<DynamicFlatNode>, public appService: AppService) {
  }

  connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
    this._treeControl.expansionModel.changed.subscribe(change => {
      if ((change as SelectionChange<DynamicFlatNode>).added ||
        (change as SelectionChange<DynamicFlatNode>).removed) {
        this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
      }
    });

    return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
  }

  /** Handle expand/collapse behaviors */
  handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
    if (change.added) {
      change.added.forEach(node => this.toggleNode(node, true));
    }
    if (change.removed) {
      change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
    }
  }

  /**
   * Toggle the node, remove from display list
   */
  toggleNode(node: DynamicFlatNode, expand: boolean) {

    const index = this.data.indexOf(node);
    if (!expand) {
      let count = 0;
      for (let i = index + 1; i < this.data.length
        && this.data[i].level > node.level; i++, count++) { }
      this.data.splice(index + 1, count);
      this.dataChange.next(this.data);
    }
    else {
      node.isLoading = true;
      let data = node.item.split("(")
      if (node.level == 2) {
        this.appService.getSubNodesForSubModule(node.subModule, data[0], this.appService.getRouteOfMyTask()).subscribe((data: any) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].cnt == null) {
              data[i].cnt = 0;
            }

          }
          if (!data || index < 0) { // If no children, or cannot find the node, no op
            node.isLoading = false;

            return;
          }
          if (expand) {
            const nodes = data.map((obj: any) =>
              new DynamicFlatNode(obj.status + "(" + obj.cnt + ")", obj.moduleName, obj.subModuleName, obj.moduleCode, node.level + 1, obj.expandable));
            this.data.splice(index + 1, 0, ...nodes);
            console.log(this.data)
          }
          node.isLoading = false;
          // notify the change
          this.dataChange.next(this.data);

        })
      } else {
        this.appService.getSubNodesForMyTask(data[0], this.appService.getRouteOfMyTask()).subscribe((data: any) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].cnt == null) {
              data[i].cnt = 0;
            }
          }
          if (!data || index < 0) { // If no children, or cannot find the node, no op
            node.isLoading = false;

            return;
          }
          if (expand) {
            const nodes = data.map((obj: any) =>
              new DynamicFlatNode(obj.status + "(" + obj.cnt + ")", "My Tasks", obj.moduleName, obj.moduleCode, node.level + 1, obj.expandable));
            this.data.splice(index + 1, 0, ...nodes);
            console.log(this.data)
          }
          node.isLoading = false;
          // notify the change
          this.dataChange.next(this.data);

        })
      }

    }
  }


}

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.scss']
})
export class MyTasksComponent implements OnInit {

  treeControl: FlatTreeControl<DynamicFlatNode>;
  isProcessing: any = false;
  dataSource: any;
  searchValue = "";
  searchValueForMyTask = "";
  getLevel = (node: DynamicFlatNode) => node.level;

  copyObjToRefreshGrid: any = {};


  expandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;
  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  pickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleConfirmFinding: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmFindingPopup', { static: true }) confirmFindingPopup: TemplateRef<any>;

  confirmFindingPopupConfig = {
    width: '110%',
    //height: '85%',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { left: '105px', top: '5px' },
    maxWidth: '93vw',

    /*  width: '90%',
     panelClass: 'my-dialog',
     hasBackdrop: false,
     position: { top: '10px' }, */
  };

  visibleFeedbackPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('feedbackPopup', { static: true }) feedbackPopup: TemplateRef<any>;

  feedbackPopupPopupConfig = {
    width: '1200px',
    //height: '85%',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  qualityGroupList: any = [];

  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled: boolean = false;
  constructor(public dialog: MatDialog, public appService: AppService, public paginationService: PaginationService,
    public qmsservice: qmsService, public message: messageService, public router: Router, private snackBar: MatSnackBar,
    public auService: AuService, public auComponent: AuComponent, private sanitizer: DomSanitizer, private authService: MsalService,
    private dependencyNavigationService: DependencyNavigationService) {
    //this.qmsservice.taskModuleName=='';
    this.message.showComplaintSwitch = true;
    this.message.showIncidentSwitch = true;

    this.appService.getQmsGroups().subscribe((group: any) => {
      this.qualityGroupList = group;
    })
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  tmsSettingsObj: any = {};
  userName: any = "";
  password: any = "";
  totalCount: any = 0;
  feedbackTemplateList: any = [];
  isMyTaskFromDashoboard = false;
  displayUserName: any;
  moduleList: any = [];
  ngOnInit(): void {
    this.isProcessing = true;
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.isMyTaskFromDashoboard = this.message.isMyTaskFromDashboard;
    this.appService.myTaskCount = this.appService.myTaskCount + 1;
    this.message.breadcrumbData.secondLevel = null;
    this.message.breadcrumbData.thirdLevel = null;
    this.message.breadcrumbData.fourthLevel = null;
    let route = this.appService.getRouteOfMyTask();
    this.dependencyNavigationService.clear();
    this.qmsservice.isTriggeredFromDependencies = false;
    if (route == "All") {
      this.selectedIs = "allTasks"
    } else {
      this.selectedIs = "tillToday"
    }
    this.appService.getFeedbackTemplatesList().subscribe((data: any) => {
      this.feedbackTemplateList = data;
    })
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;

    this.displayOrHideTab(0, false);
    this.qmsservice.taskModuleName = '';
    const codeListsRequests = [
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_FOR"),
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_OUTCOME"),
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_METHODOLOGY"),
      this.appService.getCodeListsByGroup("DOCUMENT_TYPE"),
      this.appService.getCodeListsByGroup("MODULES"),
    ];
    this.userName = localStorage.getItem("loggedUserName");
    this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
      if (response != null) {
        this.tmsSettingsObj = response;
      } else {
        this.tmsSettingsObj = {};
      }
    });
    forkJoin(codeListsRequests).subscribe(
      ([checkRequiredForData, outcomeData, methodologyData, documentTypeData, modules]) => {
        this.dropDownDataForCheckRequiredFor = checkRequiredForData;
        this.dropDownDataForOutcome = outcomeData;
        this.dropDownDataForMethodology = methodologyData;
        this.dropDownDataForDocumentType = documentTypeData;
        this.moduleList = modules;
        this.selectBoxForCheckRequiredFor();
        this.selectBoxForOutcome();
        this.selectBoxForMethodology();
        this.isProcessing = false;
        //this.selectBoxForDocumentType();
      },
      () => {
        this.isProcessing = false;
      }
    );




    this.message.taskLevelData = {
      subModuleName: ""
    }
    this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
      if (res != null) {
        this.totalCount = res;
      }
    })
    this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.expandable);
    this.dataSource = new DynamicDataSource(this.treeControl, this.appService);
    this.appService.getSubNodesForMyTask("My Tasks", this.appService.getRouteOfMyTask()).subscribe((data: any) => {

      if (!data) { // If no children, or cannot find the node, no op
        return;
      }

      this.dataSource.data = data.map((obj: any) =>

        new DynamicFlatNode(obj.status + "(" + obj.cnt + ")", "My Tasks", obj.moduleName, obj.moduleCode, 1, obj.expandable));
      // this.data.splice(index + 1, 0, ...nodes);


      //this.treeControl.expandAll();

    })
    //})
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  selectedIs: any;
  selectmyTaskVal(val: any) {
    this.selectedIs = val;
    if (val == "allTasks") {
      this.appService.setRouteOfMyTask("All");
    } else {
      this.appService.setRouteOfMyTask("Calendar");
    }
    this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
      if (res != null) {
        this.totalCount = res;
      }
    })
    this.isProcessing = true;
    this.appService.getSubNodesForMyTask("My Tasks", this.appService.getRouteOfMyTask()).subscribe((data: any) => {
      this.isProcessing = false;
      if (!data) { // If no children, or cannot find the node, no op
        return;
      }

      this.dataSource.data = data.map((obj: any) =>

        new DynamicFlatNode(obj.status + "(" + obj.cnt + ")", "My Tasks", obj.moduleName, obj.moduleCode, 1, obj.expandable));
      // this.data.splice(index + 1, 0, ...nodes);


      //this.treeControl.expandAll();

    })
  }

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;
  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  onSearchChange() {
    this.setPage(1, 0);

  }
  // In your component .ts file
  setPage(page: number, targetpage: number) {

    if (Number.isNaN(page) || page < 1) {
      page = 1;
    }
    let filteredList: any[];
    if (!this.taskDetailList || this.taskDetailList.length === 0) {
      filteredList = [];
    } else if (!this.searchValue || this.searchValue.trim() === '') {
      filteredList = [...this.taskDetailList]; // Create a shallow copy
    } else {
      const searchLower = this.searchValue.toLowerCase().trim();
      filteredList = this.taskDetailList.filter((item: any) =>
        Object.values(item).some((val: any) => {
          if (typeof val === 'string') {
            return val.toLowerCase().includes(searchLower);
          }
          else if (typeof val === 'number') {
            return val.toString().includes(this.searchValue);
          }
          return false;
        })
      );
    }
    this.collectionSize = filteredList.length;
    this.pager = this.paginationService.getPager(this.collectionSize, page, this.perPage, targetpage);

    if (page > this.pager.totalPages && this.pager.totalPages > 0) {
      page = this.pager.totalPages;
      this.pager = this.paginationService.getPager(this.collectionSize, page, this.perPage, targetpage);
    }

    this.pagedItems = filteredList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  highlight(node: any) {
    node.highlight = true;
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.taskDetailList.length; p++) {
        this.taskDetailList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.taskDetailList.length; p++) {
        this.taskDetailList[p].childCheckBoxs = false;
      }
    }
  }
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  passwordFieldValue: any;
  commentsFieldValue: any;
  comments: any;
  onPasswordFieldFocusout() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comment-validation') as HTMLInputElement;

    if (this.passwordFieldValue != undefined) {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '';
      }
    }

    if (this.commentsFieldValue != undefined) {
      if (this.comments == '' || this.comments == undefined || this.comments == null) {
        this.commentsFieldValue.style.color = 'red';
      } else {
        this.commentsFieldValue.style.color = '';
      }
    }
  }
  isEsignRequired: boolean;
  bulkReviewApprove() {
    this.comments = '';
    this.password = '';
    this.isEsignRequired = true;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  @ViewChild('messagePopup', { static: true }) messagePopup: TemplateRef<any>;
  visiblemessagePopup: MatDialogRef<TemplateRef<any>>;
  messagePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  openMessages() {
    this.visiblemessagePopup = this.dialog.open(this.messagePopup, this.messagePopupConfig);
  };
  closeMessage() {
    this.visiblemessagePopup.close();
  }
  fileExtn: any;
  buttonOperationFile: any | File;
  messageList: any = [];
  confirmOkFunc() {

    if (localStorage.getItem("adEnabled") == 'Y') {
      if ((this.comments)) {
        this.authEnable("confirmOkFunc");
      } else {
        alert('Please enter the comments.');
      }
    } else {

      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          //if ((this.rejectReasonList.length > 0 && (this.selectedReasonValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "") || (this.comments == null || this.comments == "")) {
          if ((this.comments == null || this.comments == "")) {
            this.onPasswordFieldFocusout();
            alert('Please enter the all mandatory fields...');
            this.isProcessing = false;
          } else {
            this.confirmOkFunctioncall();
          }
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }
  confirmOkFunctioncall() {

    if (this.clickedData.title == 'User Deactivation Approval') {
      this.deactivateUser();
      return;
    }

    let p = 0;
    let list1 = this.taskDetailList.filter((vendor: any) => vendor.childCheckBoxs == true);
    this.messageList = [];
    for (let j = 0; j < list1.length; j++) {
      let data = {
        moduleName: list1[j].moduleCode,
        taskNo: list1[j].taskNo,
        status: this.status,
        stageName: null,
        buttonValue: "Approve",
        actionStatus: "",
        comments: this.comments,
        rejectReason: "",
        reasonForSignature: "",
        fileExtn: this.fileExtn,
      }

      const formData = new FormData();
      const emptyfile: File | any = null;
      formData.append('file', this.buttonOperationFile);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performQualityBtnOperation(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        p = p + 1;
        if (Response.resultType == "S") {
          this.isProcessing = true;
          this.visibleDeletePopup.close();
          this.openLeftSideGridFunc(this.clickedData);
          this.messageList.push(Response);
          if (p == 1) {
            this.openMessages();
            this.showvulkreviewbtn = false;
          }

        }

        this.isProcessing = false;
      })
    }


  }
  cancelConfirmFunc() {
    this.visibleDeletePopup.close();
  }
  showvulkreviewbtn: boolean = false;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    //console.log(e);
    //console.log(list);
    //console.log(idx);
    if (e.target.checked) {
      list[idx].childCheckBoxs = true;
    } else {
      list[idx].childCheckBoxs = false;
    }
    let list1 = list?.filter((vendor: any) => vendor.childCheckBoxs == true);
    if (list1.length > 0) {
      this.showvulkreviewbtn = true;
    } else {
      this.showvulkreviewbtn = false;
    }
  }
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  ngAfterViewInit() {
    this.displayOrHideTab(0, false);
  }

  datepickerDateCustomClasses: DatepickerDateCustomClasses[];
  isShowInfoGrid: boolean = false;
  taskDetailList: any = [];
  clickedData: any = {};
  status: any;
  activeNode: any = "";
  selectedTabIndex = 1;
  openLeftSideGridFunc(data: any) {
    this.multiArray = [];
    console.log(this.multiArray.length, "====================")
    this.showvulkreviewbtn = false;
    this.activeNode = data;
    this.selectedTabIndex = 1;
    this.selectedTabIndex = 0;
    this.displayOrHideTab(0, true);
    console.log(0);
    this.clickedData = data;
    if (data.level == 3) {
      let item1: boolean = true;
      this.status = "";
      this.clickedData.title = data.parentModule;
      this.clickedData.module = "MYTASK";
      this.taskDetailList = [];
      let statusArray = data.item.split("(");
      for (let k = data.item.length - 1; k >= 0; k--) {
        if (data.item[k] == "(") {
          if (item1 == true) {
            this.status = data.item.slice(0, k);
            item1 = false;
          }


        }
      }
      //this.status = data.item.split("(")[0];
      console.log(this.status);

      this.isProcessing = true;
      const data2 = {

        module: data.moduleCode,
        status: this.status,
        subModule: data.subModule,
        isFrom: this.appService.getRouteOfMyTask()
      };
      this.appService.getSubTaskDetail(data2)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.multiArray = [];
          this.taskDetailList = data.sort((a: any, b: any) =>
            new Date(a.actionRequestedOn).getTime() - new Date(b.actionRequestedOn).getTime()
          );
          this.taskDetailList = data;
          this.collectionSize = this.taskDetailList.length;
          this.setPage(1, 0);
          this.isShowInfoGrid = true;
        })
    } else {

      let item1: boolean = true;
      if (data.subModule == "My Trainings") {
        this.appService.myTraining = "mainPage"
        this.router.navigate(['/dashboard/trainingDashboard']);
      } else {
        if (data.subModule == "Trainings") {
          this.clickedData.title = "Training";
        } else if (data.subModule == "Change Request") {
          this.clickedData.title = "CR";
        } else if (data.subModule == "Documents") {
          this.clickedData.title = "Document";
        } else {
          this.clickedData.title = data.subModule;
        }
        this.taskDetailList = [];
        //this.status = data.item.split("(")[0];
        for (let k = data.item.length - 1; k >= 0; k--) {
          if (data.item[k] == "(") {
            if (item1 == true) {
              this.status = data.item.slice(0, k);
              item1 = false;
            }


          }
        }
        this.isProcessing = true;
        const data1 = {

          module: data.moduleCode,
          status: this.status,
          isFrom: this.appService.getRouteOfMyTask()
        };
        console.log(this.status);

        this.copyObjToRefreshGrid = data1;

        this.appService.getTaskDetail(data1)
          .subscribe((data: any) => {
            this.isProcessing = false;
            this.multiArray = [];
            this.taskDetailList = data.sort((a: any, b: any) =>
              new Date(a.actionRequestedOn).getTime() - new Date(b.actionRequestedOn).getTime()
            );
            this.taskDetailList = data;
            this.collectionSize = this.taskDetailList.length;
            this.setPage(1, 0);
            this.isShowInfoGrid = true;
          })
      }

    }

  }
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  subTaskMethod(data: any) {
    if (data.subModuleName != null) {
      if (data.subTaskName?.includes("-")) {
        let temp1 = data.subTaskName.split("-");
        temp1 = temp1[1].replace(/\s/g, "");
      };
    }

    let checkReqForValue: any;
    if (data.subTaskName != null) {
      if (data.subTaskName?.includes("-")) {
        checkReqForValue = data.subTaskName.split("- ");
        console.log(checkReqForValue[1]);
      };
    }

    this.qmsservice.activityId = data.taskNo;
    this.message.activityId = data.taskNo;
    this.qmsservice.moduleName = data.moduleCode;
    this.qmsservice.moduleFullName = this.moduleList.find((x: any) => x.codelistCode == data.moduleCode).codelistName;
    if (data.status == "Closed(Effectiveness Check Pending)") {
      this.popupDataTitle = "Create Effectiveness Check";
      this.selectedCheckRequiredFor = null;
      this.selectedOwner = [];
      this.ecData.dueDate = null;
      this.ecData.remindNDaysBeforeDueDate = '';
      this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
    } else if (data.subModuleName == 'Effectiveness Check') {
      this.message.taskLevelData = {
        EC_ID: data.subTaskNo,
        CHECK_REQD_FOR: checkReqForValue[1],
        subModuleName: data.subModuleName,
        REF_NO: this.qmsservice.activityId
      }
    } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions') {
      this.message.taskLevelData = {
        ACTION_ID: data.subTaskNo,
        subModuleName: data.subModuleName
      }
    } else if (data.subModuleName == 'Parallel Workflow') {
      this.message.taskLevelData = {
        WORKFLOW_ID: data.subTaskNo,
        subModuleName: data.subModuleName
      }
    } else if (data.subModuleName == 'Extension') {
      this.message.taskLevelData = {
        REF_NO: this.qmsservice.activityId,
        EXTENSION_ID: data.subTaskNo,
        subModuleName: data.subModuleName
      }
    }
    this.isProcessing = false;
  }
  clickedGidData: any = {};
  openAddPopup(data: any) {
    const subTaskNo = data.subTaskNo;
    this.activeNode = data;
    this.selectedTabIndex = 0

    this.isProcessing = true;
    this.message.taskLevelData = {};
    this.qmsservice.cancelButtonFrom = "myTask";
    this.qmsservice.taskModuleName = data.moduleCode;
    this.qmsservice.moduleName = data.moduleCode;
    const matchedModule = this.moduleList.find((x: any) => x.codelistCode == data.moduleCode);
    this.qmsservice.moduleFullName = matchedModule?.codelistName || data.moduleCode;
    if (data.moduleCode == 'CR') {
      this.appService.getCrByCrNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        //this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);
          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }
              //this.isProcessing = false;

              this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
                this.dropDownForOwner = data1;
                this.selectBoxForOwner();

                if (data.subModuleName != null) {
                  if (data.subTaskName?.includes("-")) {
                    let temp1 = data.subTaskName.split("-");
                    temp1 = temp1[1].replace(/\s/g, "");
                  };
                }

                let checkReqForValue: any;
                if (data.subTaskName != null) {
                  if (data.subTaskName.includes("-")) {
                    checkReqForValue = data.subTaskName.split("- ");
                    console.log(checkReqForValue[1]);
                  };
                }

                this.qmsservice.activityId = data.taskNo;
                this.message.activityId = data.taskNo;
                this.qmsservice.moduleName = data.moduleCode;
                if (data.status == "Closed(Effectiveness Check Pending)") {
                  this.popupDataTitle = "Create Effectiveness Check";
                  this.selectedCheckRequiredFor = null;
                  this.selectedOwner = [];
                  this.ecData.dueDate = null;
                  this.ecData.remindNDaysBeforeDueDate = '';
                  this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
                } else if (data.subModuleName == 'Effectiveness Check') {
                  this.message.taskLevelData = {
                    EC_ID: data.subTaskNo,
                    CHECK_REQD_FOR: checkReqForValue[1],
                    subModuleName: data.subModuleName,
                    REF_NO: this.qmsservice.activityId
                  }
                } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions' || data.subModuleName == 'Preliminary Actions') {
                  this.message.taskLevelData = {
                    ACTION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.message.taskLevelData = {
                    WORKFLOW_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Extension') {
                  this.message.taskLevelData = {
                    REF_NO: this.qmsservice.activityId,
                    EXTENSION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                }
                if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
                  //this.message.showLeftMenu = "Activity";
                  this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
                  this.message.breadcrumbData.secondLevel = "Change Request" + " > " + this.selectedGroupValue[0].displayExp;
                  this.message.breadcrumbData.fourthLevel = data.taskId;
                  this.router.navigate(['dashboard/qmsCr']);
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                  this.router.navigate(['dashboard/parallelworkflowDetails']);
                }

                this.isProcessing = false;

              });
            } else {
              this.subTaskMethod(data);
            }
          });
        });
      });
    } else if (data.moduleCode == 'E-Sign') {
      this.isProcessing = false;
      this.router.navigate(['/dashboard/esignatureSign'], {
        state: {
          envelopeId: data.taskNo,
          signerId: data.subTaskNo
        }
      });
    }
    else if (data.moduleCode == 'OOS') {
      this.appService.getOosByOosNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response[0];
        //this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response[0].groupId;
        this.qmsservice.selectedGroup = response[0].groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response[0].groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response[0].groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }
              //this.isProcessing = false;

              this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
                this.dropDownForOwner = data1;
                this.selectBoxForOwner();

                if (data.subModuleName != null) {
                  if (data.subTaskName?.includes("-")) {
                    let temp1 = data.subTaskName.split("-");
                    temp1 = temp1[1].replace(/\s/g, "");
                  };
                }

                if (data.subTaskName != null) {
                  if (data.subTaskName.includes("-")) {
                    let checkReqForValue = data.subTaskName.split("- ");
                    console.log(checkReqForValue[1]);
                  };
                }

                this.qmsservice.activityId = data.taskNo;
                this.message.activityId = data.taskNo;
                this.qmsservice.moduleName = data.moduleCode;
                if (data.subModuleName == 'Actions') {
                  this.message.taskLevelData = {
                    ACTION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.message.taskLevelData = {
                    WORKFLOW_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Extension') {
                  this.message.taskLevelData = {
                    REF_NO: this.qmsservice.activityId,
                    EXTENSION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                }
                if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
                  //this.message.showLeftMenu = "Activity";
                  this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
                  this.message.breadcrumbData.secondLevel = "Change Request" + " > " + this.selectedGroupValue[0].displayExp;
                  this.message.breadcrumbData.fourthLevel = data.taskId;
                  this.router.navigate(['dashboard/qmsOOS']);
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                  this.router.navigate(['dashboard/parallelworkflowDetails']);
                }

                this.isProcessing = false;

              });
            } else {
              this.subTaskMethod(data);
            }
          });
        });
      });
    } else if (data.moduleCode == 'DV') {
      this.appService.getDvByDvNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';

        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.isProcessing = false;

              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }

              this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
                this.dropDownForOwner = data1;
                this.selectBoxForOwner();

                if (data.subModuleName != null) {
                  if (data.subTaskName?.includes("-")) {
                    let temp1 = data.subTaskName.split("-");
                    temp1 = temp1[1].replace(/\s/g, "");
                  };
                }

                let checkReqForValue: any;
                if (data.subTaskName != null) {
                  if (data.subTaskName.includes("-")) {
                    checkReqForValue = data.subTaskName.split("- ");
                    console.log(checkReqForValue[1]);
                  };
                }

                this.qmsservice.activityId = data.taskNo;
                this.message.activityId = data.taskNo;
                this.qmsservice.moduleName = data.moduleCode;
                if (data.status == "Closed(Effectiveness Check Pending)") {
                  this.popupDataTitle = "Create Effectiveness Check";
                  this.selectedCheckRequiredFor = null;
                  this.selectedOwner = [];
                  this.ecData.dueDate = null;
                  this.ecData.remindNDaysBeforeDueDate = '';
                  this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
                } else if (data.subModuleName == 'Effectiveness Check') {
                  this.message.taskLevelData = {
                    EC_ID: data.subTaskNo,
                    CHECK_REQD_FOR: checkReqForValue[1],
                    subModuleName: data.subModuleName,
                    REF_NO: this.qmsservice.activityId
                  }
                } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions' || data.subModuleName == 'Preliminary Actions') {
                  this.message.taskLevelData = {
                    ACTION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.message.taskLevelData = {
                    WORKFLOW_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Extension') {
                  this.message.taskLevelData = {
                    REF_NO: this.qmsservice.activityId,
                    EXTENSION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                }
                if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
                  //this.message.showLeftMenu = "Activity";
                  this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
                  this.message.breadcrumbData.secondLevel = "Deviation" + " > " + this.selectedGroupValue[0].displayExp;
                  this.message.breadcrumbData.fourthLevel = data.taskId;
                  this.router.navigate(['dashboard/dv']);
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                  this.router.navigate(['dashboard/parallelworkflowDetails']);
                }

              });
            } else {
              this.subTaskMethod(data);
            }
          });

        });

      });
    } else if (data.moduleCode == 'CAPA') {
      this.appService.getCapaVwDetailsByCapaNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.isProcessing = false;

              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }

              this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
                this.dropDownForOwner = data1;
                this.selectBoxForOwner();

                if (data.subModuleName != null) {
                  if (data.subTaskName?.includes("-")) {
                    let temp1 = data.subTaskName.split("-");
                    temp1 = temp1[1].replace(/\s/g, "");
                  };
                }

                let checkReqForValue: any;
                if (data.subTaskName != null) {
                  if (data.subTaskName.includes("-")) {
                    checkReqForValue = data.subTaskName.split("- ");
                    console.log(checkReqForValue[1]);
                  };
                }

                this.qmsservice.activityId = data.taskNo;
                this.message.activityId = data.taskNo;
                this.qmsservice.moduleName = data.moduleCode;

                if (data.status == "Closed(Effectiveness Check Pending)") {
                  this.popupDataTitle = "Create Effectiveness Check";
                  this.selectedCheckRequiredFor = null;
                  this.selectedOwner = [];
                  this.ecData.dueDate = null;
                  this.ecData.remindNDaysBeforeDueDate = '';
                  this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
                } else if (data.subModuleName == 'Effectiveness Check') {
                  this.message.taskLevelData = {
                    EC_ID: data.subTaskNo,
                    CHECK_REQD_FOR: checkReqForValue[1],
                    subModuleName: data.subModuleName,
                    REF_NO: this.qmsservice.activityId
                  }
                } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions') {
                  this.message.taskLevelData = {
                    ACTION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.message.taskLevelData = {
                    WORKFLOW_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                } else if (data.subModuleName == 'Extension') {
                  this.message.taskLevelData = {
                    REF_NO: this.qmsservice.activityId,
                    EXTENSION_ID: data.subTaskNo,
                    subModuleName: data.subModuleName
                  }
                }
                if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
                  //this.message.showLeftMenu = "Activity";
                  this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
                  this.message.breadcrumbData.secondLevel = "Capa" + " > " + this.selectedGroupValue[0].displayExp;
                  this.message.breadcrumbData.fourthLevel = data.taskId;
                  this.router.navigate(['dashboard/capa']);
                } else if (data.subModuleName == 'Parallel Workflow') {
                  this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                  this.router.navigate(['dashboard/parallelworkflowDetails']);
                }

              });
            } else {
              this.subTaskMethod(data);
            }
          });
        });
      });
    } else if (data.moduleCode == 'IN') {
      this.appService.getIncidentDetailsByInNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
              this.isProcessing = false;

              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }


            }
            if (data.subModuleName != null) {
              if (data.subTaskName?.includes("-")) {
                let temp1 = data.subTaskName.split("-");
                temp1 = temp1[1].replace(/\s/g, "");
              };
            }

            let checkReqForValue: any;
            if (data.subTaskName != null) {
              if (data.subTaskName.includes("-")) {
                checkReqForValue = data.subTaskName.split("- ");
                console.log(checkReqForValue[1]);
              };
            }

            this.qmsservice.activityId = data.taskNo;
            this.message.activityId = data.taskNo;
            this.qmsservice.moduleName = data.moduleCode;
            if (data.subModuleName == 'Effectiveness Check') {
              this.message.taskLevelData = {
                EC_ID: data.subTaskNo,
                CHECK_REQD_FOR: checkReqForValue[1],
                subModuleName: data.subModuleName,
                REF_NO: this.qmsservice.activityId
              }
            } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions') {
              this.message.taskLevelData = {
                ACTION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Parallel Workflow') {
              this.message.taskLevelData = {
                WORKFLOW_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Extension') {
              this.message.taskLevelData = {
                REF_NO: this.qmsservice.activityId,
                EXTENSION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            }
            if (data.subModuleName == null) {
              this.message.breadcrumbData.secondLevel = "Incident" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = data.taskId;
              this.router.navigate(['dashboard/in']);
            } else if (data.subModuleName == 'Parallel Workflow') {
              this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
              this.router.navigate(['dashboard/parallelworkflowDetails']);
            }
          });
        });
      });
    } else if (data.moduleCode == 'QI') {
      this.appService.getQiVwDetailsByQiNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
              this.isProcessing = false;

              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }
            }

            if (data.subModuleName != null) {
              if (data.subTaskName?.includes("-")) {
                let temp1 = data.subTaskName.split("-");
                temp1 = temp1[1].replace(/\s/g, "");
              };
            }

            let checkReqForValue: any;
            if (data.subTaskName != null) {
              if (data.subTaskName.includes("-")) {
                checkReqForValue = data.subTaskName.split("- ");
                console.log(checkReqForValue[1]);
              };
            }


            this.qmsservice.activityId = data.taskNo;
            this.message.activityId = data.taskNo;
            this.qmsservice.moduleName = data.moduleCode;

            this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
              this.dropDownForOwner = data1;
              this.selectBoxForOwner();
            })

            if (data.status == "Closed(Effectiveness Check Pending)") {
              this.popupDataTitle = "Create Effectiveness Check";
              this.selectedCheckRequiredFor = null;
              this.selectedOwner = null;
              this.ecData.dueDate = null;
              this.ecData.remindNDaysBeforeDueDate = '';
              this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
            } else if (data.subModuleName == 'Effectiveness Check') {
              this.message.taskLevelData = {
                EC_ID: data.subTaskNo,
                CHECK_REQD_FOR: checkReqForValue[1],
                subModuleName: data.subModuleName,
                REF_NO: this.qmsservice.activityId
              }
            } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions') {
              this.message.taskLevelData = {
                ACTION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Parallel Workflow') {
              this.message.taskLevelData = {
                WORKFLOW_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            } else if (data.subModuleName == 'Extension') {
              this.message.taskLevelData = {
                REF_NO: this.qmsservice.activityId,
                EXTENSION_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
            }
            if (data.subModuleName == null && data.status != "Closed(Effectiveness Check Pending)") {
              this.message.breadcrumbData.secondLevel = "Quality Issue" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = data.taskId;
              this.router.navigate(['dashboard/qi']);
            } else if (data.subModuleName == 'Parallel Workflow') {
              this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
              this.router.navigate(['dashboard/parallelworkflowDetails']);
            }
          });
        });
      });
    } else if (data.moduleCode == 'CC') {
      this.appService.getCcDetailsByCcNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;
          data.subModuleName == 'Preliminary Actions' && this.initiatePreActionService(data.taskNo);

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            if (response1.length > 0) {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.isProcessing = false;

              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
                this.qmsservice.loggedInitiaor = true;
              } else {
                this.qmsservice.loggedInitiaor = false;
              }

              if (data.subModuleName != null) {
                if (data.subTaskName?.includes("-")) {
                  let temp1 = data.subTaskName.split("-");
                  temp1 = temp1[1].replace(/\s/g, "");
                };
              }

              let checkReqForValue: any;

              if (data.subTaskName != null) {
                if (data.subTaskName?.includes("-")) {
                  checkReqForValue = data.subTaskName.split("- ");
                  console.log(checkReqForValue[1]);
                };
              }

              this.qmsservice.activityId = data.taskNo;
              this.message.activityId = data.taskNo;
              this.qmsservice.moduleName = data.moduleCode;
              if (data.subModuleName == 'Effectiveness Check') {
                this.message.taskLevelData = {
                  EC_ID: data.subTaskNo,
                  CHECK_REQD_FOR: checkReqForValue[1],
                  subModuleName: data.subModuleName,
                  REF_NO: this.qmsservice.activityId
                }
              } else if (data.subModuleName == 'Actions' || data.subModuleName == 'Preliminary Actions') {
                this.message.taskLevelData = {
                  ACTION_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
              } else if (data.subModuleName == 'Parallel Workflow') {
                this.message.taskLevelData = {
                  WORKFLOW_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
              } else if (data.subModuleName == 'Extension') {
                this.message.taskLevelData = {
                  REF_NO: this.qmsservice.activityId,
                  EXTENSION_ID: data.subTaskNo,
                  subModuleName: data.subModuleName
                }
              }
              if (data.subModuleName == null) {
                this.message.breadcrumbData.secondLevel = "Customer Complain" + " > " + this.selectedGroupValue[0].displayExp;
                this.message.breadcrumbData.fourthLevel = data.taskId;
                this.router.navigate(['dashboard/cc']);
              } else if (data.subModuleName == 'Parallel Workflow') {
                this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
                this.router.navigate(['dashboard/parallelworkflowDetails']);
              }
            } else {
              this.subTaskMethod(data);
            }
          });
        });
      });
    } else if (data.moduleCode == 'AU') {
      this.qmsservice.activityId = this.message.activityId = data.taskNo;
      this.auService.auditPageFrom = "MyTask";
      this.qmsservice.auditEditmodeDatas = { pageName: "" };
      if (data.subModuleName == 'Effectiveness Check' || data.subModuleName == 'Extension' || data.subModuleName == 'Findings' || data.subModuleName == 'Followups' || data.subModuleName == 'Followup') {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.auService.findingId = data.subTaskNo;

        this.qmsservice.moduleName = "AU";
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          this.auService.isAuditor = data.leadAuditor == this.message.getUserId();
          this.qmsservice.activity = data;
          this.appService.getQmsGroupDetailsByModule(data.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
            this.qmsservice.selectedGroupDetailData = data1;
          });
          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;

            const groupName = this.qualityGroupList.find((g: any) => g.groupId == data.groupId);
            this.selectedGroupValue = [{
              valueExp: data.groupId,
              displayExp: groupName
            }];
            this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;
            this.qmsservice.selectedGroupDetailId = this.qmsservice.selectedGroupDetailData.groupDetailId;
            this.qmsservice.selectedGroup = data.groupId;
            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.qmsservice.selectedGroup = data.groupId;
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            list.STATUS = data.status;
            this.qmsservice.activity = data;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.popupDataTitle = data.auId;

            let checkReqForValue: any;
            if (this.activeNode.subTaskName != null) {
              if (this.activeNode.subTaskName.includes("-")) {
                checkReqForValue = this.activeNode.subTaskName.split("- ");
                console.log(checkReqForValue[1]);
              };
            }

            if (this.activeNode.subModuleName == 'Effectiveness Check') {
              this.message.taskLevelData = {
                EC_ID: this.activeNode.subTaskNo,
                CHECK_REQD_FOR: checkReqForValue[1],
                subModuleName: this.activeNode.subModuleName,
                REF_NO: this.qmsservice.activityId
              }
            } else if (this.activeNode.subModuleName == 'Extension') {
              this.message.taskLevelData = {
                REF_NO: this.qmsservice.activityId,
                EXTENSION_ID: this.activeNode.subTaskNo,
                subModuleName: this.activeNode.subModuleName
              }
            } else if (data.subModuleName == 'Parallel Workflow') {
              this.message.taskLevelData = {
                WORKFLOW_ID: data.subTaskNo,
                subModuleName: data.subModuleName
              }
              this.qmsservice.workflowId = this.message.taskLevelData.WORKFLOW_ID;
              this.router.navigate(['dashboard/parallelworkflowDetails']);
            } else if (this.activeNode.subModuleName == 'Findings') {
              this.qmsservice.activity.isRiskCalculationReqd = this.qmsservice.activity.isRiskCalculationReqd == "Y" ? true : false;
              this.appService.getAuFindingByFindingId(subTaskNo).subscribe((data: any) => {
                this.auService.findingsData.SEQ = data.seq;
                this.visibleConfirmFinding = this.dialog.open(this.confirmFindingPopup, this.confirmFindingPopupConfig);
              });

            } else if (this.activeNode.subModuleName == 'Followups' || this.activeNode.subModuleName == 'Followup') {
              this.message.taskLevelData = {
                AU_NO: this.qmsservice.activityId,
                FOLLOWUP_ID: this.activeNode.subTaskNo,
                subModuleName: this.activeNode.subModuleName
              }
            }

          });

        })
      }
      else if (this.auService.auditScheduleStatusList.indexOf(data.status) != -1) {
        this.auService.tabName = "Annual Audit Schedule";
        this.isProcessing = false;
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          //this.qmsservice.auditEditmodeDatas = { pageName: this.selectedTab };

          this.auService.list = {};
          this.message.activityId = this.qmsservice.activityId = this.auService.list.AU_NO = data.auNo;
          this.qmsservice.selectedGroup = this.qmsservice.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
          //this.message.breadcrumbData.secondLevel="Audit" +" > "+ this.selectedGroupValue[0].displayExp;
          this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
          this.qmsservice.activity = {};
          this.qmsservice.activity.status = this.auService.list.STATUS = data.status;
          this.qmsservice.getQmsActionDataUsingById = {};
          this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
            this.dropDownForAuditGroup = response1;
            this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
            this.qmsservice.groupNameAndValue = this.selectedGroupValue = [{
              displayExp: this.auService.priorGroup?.groupId,
              valueExp: this.auService.priorGroup?.groupName
            }];
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].groupName;

            this.qmsservice.auditEditmodeDatas = { pageName: "Annual Audit Schedule" };
            //this.auComponent.ngOnInit();
            this.isProcessing = false;
          });
          this.isProcessing = false;
        });

      } else if (data.status.includes("Initiated")) {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          this.appService.getQmsGroupDetailsByModule(data.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
            this.qmsservice.selectedGroupDetailData = data1;
          });
          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;
            this.selectedGroupValue = [{
              valueExp: this.qmsservice.userRole[0].groupId,
              displayExp: this.qmsservice.userRole[0].groupName
            }];
            this.qmsservice.selectedGroup = this.qmsservice.userRole[0].groupId,
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;
            this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.router.navigate(['/dashboard/auDetailPage']);

          });

        })

      } else if (this.auService.auditPlanStatusList.indexOf(data.status) != -1) {
        this.auService.tabName = "Audit Plan";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          //this.qmsservice.auditEditmodeDatas = { pageName: this.selectedTab };
          this.appService.getQmsGroupDetailsByModule(data.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
            this.qmsservice.selectedGroupDetailData = data1;
          });
          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;
            this.selectedGroupValue = [{
              valueExp: this.qmsservice.userRole[0].groupId,
              displayExp: this.qmsservice.userRole[0].groupName
            }];
            this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;
            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.auService.list = {};
            this.message.activityId = this.qmsservice.activityId = this.auService.list.AU_NO = data.auNo;
            this.qmsservice.selectedGroup = this.qmsservice.selectedActivityGroupId = this.auService.list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = this.auService.list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
              this.dropDownForAuditGroup = response1;

              this.auService.priorGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
              this.qmsservice.auditEditmodeDatas = { pageName: "Audit Plan" };
              //this.auComponent.ngOnInit();
              this.isProcessing = false;
            });
            this.isProcessing = false;

          });

        });
        this.isProcessing = false;
      } else {
        this.isProcessing = false;
        this.qmsservice.activityDynamicButtonList = [];
        this.auService.tabName = 'Conduct Audit';
        this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
        //this.auComponent.ngOnInit();
        this.qmsservice.cancelButtonFrom = "myTask";
        this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
          this.appService.getQmsGroupDetailsByModule(data.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
            this.qmsservice.selectedGroupDetailData = data1;
          });
          this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;
            this.selectedGroupValue = [{
              valueExp: this.qmsservice.userRole[0].groupId,
              displayExp: this.qmsservice.userRole[0].groupName
            }];
            this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;
            this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
              this.qmsservice.loggedAuditor = true;
            } else {
              this.qmsservice.loggedAuditor = false;
            }

            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            let list: any = {};
            this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
            this.qmsservice.selectedGroup = this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
            this.qmsservice.activity = {};
            this.qmsservice.activity.status = list.STATUS = data.status;
            this.qmsservice.getQmsActionDataUsingById = {};
            this.router.navigate(['/dashboard/auDetailPage']);

          });

        })

      }
    }
  }


  private initiatePreActionService(activityRefNo: any): any {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.qmsservice.activity.status] || 'NotInStage';
    this.appService.getTaskStageUsers(activityRefNo, 0, stageName).subscribe((stageUser: any) => {
      const taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
      const loggedUserId = this.message.getUserId();
      const { initiatedBy, owner, evaluator, qaUser, departmentHead, investigator, status } = this.qmsservice.activity;

      const isInitiator = initiatedBy == +loggedUserId!;
      const isOwner = owner == +loggedUserId!;
      const isEvaluator = evaluator == loggedUserId;
      const ccHandler = this.qmsservice.selectedGroupDetailData.activityHandler
      const isInvestigator = investigator == loggedUserId;
      const isEditableByInvestigator = this.qmsservice.selectedGroupDetailData.editableByInvestigator == "Y";
      const isQa = qaUser == +loggedUserId!;
      const isEditableByQa = this.qmsservice.selectedGroupDetailData.editableByQA == 'Y';
      const isDeptHead = departmentHead == +loggedUserId!;
      const isEditableByDeptHead = this.qmsservice.selectedGroupDetailData.editableByDepartmentHead == "Y";
      const isReviewer = taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
      const isEditableByReviewer = this.qmsservice.selectedGroupDetailData.editableByReviewers == "Y";
      const isApprover = taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
      const isEditableByApprover = this.qmsservice.selectedGroupDetailData.editableByApprovers == "Y";

      this.message.showPreActionsActionButtons = this.qmsservice.$preActionsAestheticResolver({
        status: status,
        isInitiator,
        isOwner,
        isEvaluator,
        isQa,
        isEditableByQa,
        isDeptHead,
        isEditableByDeptHead,
        isInvestigator,
        isEditableByInvestigator,
        isReviewer,
        isEditableByReviewer,
        isApprover,
        isEditableByApprover,
        ccHandler
      });
    });
  }


  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }
  cancelFindings() {
    this.visibleConfirmFinding.close();
  }
  dropDownForAuditGroup: any;
  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  addPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  documentData: any = {};
  trainingData: any = {};
  dropDownForCategories: any = [];
  dropDownFordocumentTypeList: any = [];
  dueDate: any;
  title: any;
  isShowDueDate: boolean = false;
  scheduledTrainingFieldData: any = {};
  formObj: any = {};
  feedbackQuestionsList: any;
  feedbackData: any;
  openDetailPage(data: any, event: any) {
    event.preventDefault();
    if (this.clickedData.title == "Document") {
      this.isProcessing = true;
      this.appService.getDocumentByDocumentId(
        data.taskNo, data.version).subscribe((data: any) => {
          this.documentData = data[0];
          this.appService.setParentFolderId(this.documentData.folderId);
          this.appService.getDocumentTypeBasedOnModule("DOCS")
            .subscribe((data: any) => {
              this.dropDownFordocumentTypeList = data;
              this.isProcessing = false;
              this.appService.prevDocumentId = null;
              this.appService.prevDocVersion = null;
              this.router.navigate(['/dashboard/addDocument'], {
                state: {
                  documentData: this.documentData,
                  dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
                }
              });
            })
        })
    } else if (this.clickedData.title == "Forms and Logs") {
      this.isProcessing = true;
      this.appService.getFormByFormId(
        data.taskNo).subscribe((data: any) => {
          this.formObj = data[0];
          this.isProcessing = false;
          this.message.breadcrumbData.firstLevel = "My Task";
          this.message.breadcrumbData.secondLevel = this.formObj.formName;
          this.router.navigate(['/dashboard/formsAndLogsDetail'], {
            state: {
              formObj: this.formObj
            }
          });
        })
    } else if (this.clickedData.title == "Forms and Logs Template") {
      this.isProcessing = true;
      this.appService.getFormTemplateByTemplateId(data.taskNo).subscribe((response: any) => {
        //this.formTemplateData = response[0];
        this.router.navigate(['/dashboard/formTemplateDetail'], {
          state: {
            formTemplateData: response[0]
          }
        });
      })
    } else if (this.clickedData.title == "Forms and Logs Section Data") {
      this.isProcessing = true;
      this.appService.getFormSectionDataByRecordId(data.taskNo).subscribe((response: any) => {
        this.isProcessing = false;
        if (response.length > 0) {
          this.isProcessing = true;
          this.appService.getFormByFormId(
            response[0].formId).subscribe((data: any) => {
              this.formObj = data[0];
              this.isProcessing = false;
              this.message.breadcrumbData.firstLevel = "My Task";
              this.message.breadcrumbData.secondLevel = this.formObj.formName;
              this.router.navigate(['/dashboard/formsAndLogsDetail'], {
                state: {
                  formObj: this.formObj
                }
              });
            })
        }

      })
    } else if (this.clickedData.title == "Instructor Training") {
      this.isProcessing = true;
      this.appService.getScheduledTrainingById(data.taskNo).subscribe((response: any) => {
        this.scheduledTrainingFieldData = response[0];
        this.isProcessing = false;
        this.scheduledTrainingFieldData.isShowTrainingAssessmentFlag = false;
        this.scheduledTrainingFieldData.isFromDashboard = true;
        this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication == "Y" ? true : false;
        this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 = this.scheduledTrainingFieldData.allowUsersToTakeAssessmentAtApplication;
        this.scheduledTrainingFieldData.scheduledStartDate = new Date(this.scheduledTrainingFieldData.scheduledStartDate);
        this.scheduledTrainingFieldData.scheduledEndDate = new Date(this.scheduledTrainingFieldData.scheduledEndDate);
        this.router.navigate(['/dashboard/scheduleTrainingDetail'], {
          state: {
            isShowTakeAssessmentField: false,
            trainingScheduleId: this.scheduledTrainingFieldData.trainingScheduleId,
            feedbackTemplateList: this.feedbackTemplateList
          }
        });
      })
    } else if (this.clickedData.title == "Feedback") {
      this.feedbackData = data;
      this.isProcessing = true;
      this.appService.getFeedbackTemplateQuestionListForMyTask(
        data.taskNo).subscribe((data: any) => {
          this.isProcessing = false;
          this.feedbackQuestionsList = data;
          for (let i = 0; i < this.feedbackQuestionsList.length; i++) {
            this.feedbackQuestionsList[i].selectedFlexifieldValue = "";
            if (this.feedbackQuestionsList[i].fieldTypeCode == "Drop Down" || this.feedbackQuestionsList[i].fieldTypeCode == "Check Box" || this.feedbackQuestionsList[i].fieldTypeCode == "Radio Button") {
              if (this.feedbackQuestionsList[i].fieldLovValues != null) {
                this.feedbackQuestionsList[i].dropDownValues = this.feedbackQuestionsList[i].fieldLovValues.split(",");
              }
            }
            this.feedbackQuestionsList[i].dropDownValuesForFieldScores = [];
            if (this.feedbackQuestionsList[i].fieldValueScores != null) {
              this.feedbackQuestionsList[i].dropDownValuesForFieldScores = this.feedbackQuestionsList[i].fieldValueScores.split(",");
              if (this.feedbackQuestionsList[i].fieldTypeCode != "Drop Down" && this.feedbackQuestionsList[i].fieldTypeCode != "Radio Button") {
                this.feedbackQuestionsList[i].fieldScore = this.feedbackQuestionsList[i].fieldValueScores;
              }

            }
          }
          this.appService.getFeedbackQueWithAnsw(
            this.feedbackQuestionsList[0].templateId, this.feedbackData.taskNo).subscribe((response: any) => {
              this.isProcessing = false;
              if (response.length > 0) {
                for (let i = 0; i < this.feedbackQuestionsList.length; i++) {
                  let obj = response.find((data: any) => data.feedbackFormUserQuestionsPk.questionId == this.feedbackQuestionsList[i].questionId);
                  if (obj) {
                    this.feedbackQuestionsList[i].fieldDefaultValue = obj.fieldValue;
                    if (this.feedbackQuestionsList[i].fieldTypeCode == "Drop Down" || this.feedbackQuestionsList[i].fieldTypeCode == "Radio Button") {
                      if (obj.fieldValue != null) {
                        let index = this.feedbackQuestionsList[i].dropDownValues.indexOf(obj.fieldValue);
                        if (this.feedbackQuestionsList[i].dropDownValuesForFieldScores.length > 0) {
                          this.feedbackQuestionsList[i].fieldScore = this.feedbackQuestionsList[i].dropDownValuesForFieldScores[index];
                        }
                      }

                    }
                  }
                }
              }
            })
        })
      this.visibleFeedbackPopup = this.dialog.open(this.feedbackPopup, this.feedbackPopupPopupConfig);
    } else {
      if (data.status.includes("Locked")) {
        this.dueDate = null;
        this.title = this.status;
        this.isProcessing = true;
        this.bulkorsingle = 'single';
        this.appService.getUserTrainingsByTrainingId(data.taskNo).subscribe((data: any) => {
          this.trainingData = data[0];
          this.isProcessing = false;
          if (this.status == "Locked Overdue(RM Approved)" || this.status == "Locked Overdue") {
            this.isShowDueDate = true;
            this.isProcessing = true;
            this.appService.getGroupTrainingDetailsById(this.trainingData.groupId,
              this.trainingData.trainingId, this.trainingData.version).subscribe((data: any) => {
                this.isProcessing = false;
                if (data.length > 0 && data[0].dueNDayFromOverdueUnlock != null) {
                  this.dueDate = new Date();
                  this.dueDate.setDate(new Date().getDate() + data[0].dueNDayFromOverdueUnlock)
                }
              })
          } else {
            this.isShowDueDate = false;
          }
        })
        this.password = "";
        this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
      } else {
        this.isProcessing = true;
        this.appService.getTrainingByTrainingId(data.taskNo,
          data.version).subscribe((data: any) => {
            this.isProcessing = false;
            this.trainingData = data[0];
            this.trainingData['isFromDashboard'] = true;
            this.appService.getCategoriesList().subscribe((data: any) => {
              this.dropDownForCategories = data;
              this.appService.setTrainingDetails(this.dropDownForCategories, this.trainingData);
              this.message.breadcrumbData.firstLevel = "Dashboard";
              this.message.breadcrumbData.secondLevel = "My Task";
              this.message.breadcrumbData.thirdLevel = this.trainingData.trainingName + "(" + this.trainingData.trainingCode + ")";
              this.router.navigate(['/dashboard/addTraining']);
            })
          })
      }

    }
  }

  pass: any;
  passRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }


  }


  confirmWithFunc() {

    if (this.tmsSettingsObj.esignatureAtTrainingUnlock == 'Y' && !this.isAdenabled && !this.password) {
      this.showSnackBar("Please enter the Password", "E");
      return;
    } else if (this.isShowDueDate && !this.dueDate) {
      this.showSnackBar("Please select the Due Date", "E");
      return;
    }

    if (this.tmsSettingsObj.esignatureAtTrainingUnlock == 'Y') {
      if (localStorage.getItem("adEnabled") == 'Y') {
        if (this.isShowDueDate && !this.dueDate) {
          this.isProcessing = false;
          this.dued = document.getElementById('dued') as HTMLInputElement;
          this.dueDateMsg = document.getElementById('due-required-msg') as HTMLInputElement;
          if (this.dueDate == "" || this.dueDate == null) {
            this.dued.style.border = '1px solid red';
            this.dueDateMsg.style.display = 'block';
          } else {
            this.dued.style.border = 'none';
            this.dueDateMsg.style.display = 'none';
          }
        } else {
          this.authEnable("reviewAuthenable");
        }
      } else if (!this.password) {
        this.isProcessing = false;
        this.buttonOperationFieldValidation();
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            if (this.bulkorsingle == 'single') {
              this.unlockTranning();
            } else {
              this.unlockTranningBulk();
            }

          } else {
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        })
      }
    } else {
      if (this.bulkorsingle == 'single') {

        let data = {
          userTrainingId: this.trainingData.userTrainingId,
          dueDate: this.appService.dateZoneConvertion(new Date(this.dueDate))
        }
        this.isProcessing = true;
        this.appService.unlockTraining(data).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleConfirmWithReason.close();
            this.openLeftSideGridFunc(this.clickedData);
            this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
              let data: any = [];
              if (res == null) {
                let count = 0;
                data.push("My Tasks(" + count + ")");
              } else {
                data.push("My Tasks(" + res + ")");
              }

              this.dataSource.data = data.map((name: any) => new DynamicFlatNode(name, "", "", "", 0, true));

            })
          } else {
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, (error) => {

          this.isProcessing = false;
          throw error;
        })


      } else {
        this.unlockTranningBulk();
      }

    }

  }

  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");
            if (flag == "reviewAuthenable") {
              if (this.bulkorsingle == 'single') {
                this.unlockTranning();
              } else {
                this.unlockTranningBulk();
              }
            } else if (flag == "confirmOkFunc") {
              this.confirmOkFunctioncall();
            }
            this.isProcessing = false;


          } else {
            console.log("outside");
            this.isProcessing = false;

          }

        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error)

        }
      });



  }
  unlockTranning() {
    let data1 = {
      userTrainingId: this.trainingData.userTrainingId,
      dueDate: this.appService.dateZoneConvertion(new Date(this.dueDate))
    }
    this.isProcessing = true;
    this.appService.unlockTraining(data1).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        this.visibleConfirmWithReason.close();
        this.openLeftSideGridFunc(this.clickedData);
        this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
          let data: any = [];
          if (res == null) {
            let count = 0;
            data.push("My Tasks(" + count + ")");
          } else {
            data.push("My Tasks(" + res + ")");
          }

          this.dataSource.data = data.map((name: any) => new DynamicFlatNode(name, "", "", "", 0, true));

        })
      } else {
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
    }, (error) => {

      this.isProcessing = false;
      throw error;
    })
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }


  //EC ADD
  dropDownDataForOutcome: any = [];
  dropDownDataForMethodology: any = [];
  dropDownDataForDocumentType: any = [];
  dropDownForOwner: any = [];


  popupDataTitle: any;
  selectedOwner: any = [];
  ecData: any = {};
  selectedCheckRequiredFor: any = null;
  selectedCheckRequiredForDisplayExp: any = [];
  selectedCheckRequiredForValueExp: any = [];
  checkRequiredForListDropdown: any = [];
  checkRequiredForRequiredMsg: any;
  ownerFieldRequiredMsg: any;
  dueDateRequiredMsg: any = [];
  dropDownDataForCheckRequiredFor: any = [];
  selectedGroupValue: any = [];
  groupValueDropdown: any = [];
  groupdataList: any = [];

  addStyle(node: any) {
    let val = node.level * 20;
    return {
      "padding-left": val + "px !important"
    };
  }
  checkRequiredForTxt: any;
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };
  selectBoxForCheckRequiredFor() {
    this.checkRequiredForListDropdown = [];
    for (let i = 0; i < this.dropDownDataForCheckRequiredFor.length; i++) {
      this.checkRequiredForListDropdown = this.checkRequiredForListDropdown.concat({
        valueExp: this.dropDownDataForCheckRequiredFor[i].codelistCode,
        displayExp: this.dropDownDataForCheckRequiredFor[i].codelistName
      });
    }
  }
  onCheckRequiredForSelect(event: any, item: any) {
    //
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.checkRequiredForRequiredMsg != undefined) {
          this.checkRequiredForRequiredMsg.style.color = '';
        }
      }
    }
  }

  onCheckRequiredForRemoved(item: any) {
    if (this.checkRequiredForRequiredMsg != undefined) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    }
  }

  selectedOutcome: any = [];
  outcomeListDropdown: any = [];
  selectBoxForOutcome() {
    this.outcomeListDropdown = [];
    for (let i = 0; i < this.dropDownDataForOutcome.length; i++) {
      this.outcomeListDropdown = this.outcomeListDropdown.concat({
        valueExp: this.dropDownDataForOutcome[i].codelistCode,
        displayExp: this.dropDownDataForOutcome[i].codelistName
      });
    }
  }

  selectedMethodology: any = [];
  methodologyListDropdown: any = [];
  selectBoxForMethodology() {
    this.methodologyListDropdown = [];
    for (let i = 0; i < this.dropDownDataForMethodology.length; i++) {
      this.methodologyListDropdown = this.methodologyListDropdown.concat({
        valueExp: this.dropDownDataForMethodology[i].codelistCode,
        displayExp: this.dropDownDataForMethodology[i].codelistName
      });
    }
  }

  //selectedOwner: any = [];
  ownerListDropdown: any = [];
  ownerTxt: any;
  selectBoxForOwner() {
    this.ownerListDropdown = [];
    for (let j = 0; j < this.dropDownForOwner.length; j++) {
      this.ownerListDropdown = this.ownerListDropdown.concat({
        valueExp: this.dropDownForOwner[j].userId,
        displayExp: this.dropDownForOwner[j].userName
      });
    }
  }
  onOwnerSelect(event: any, item: any) {
    //
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.ownerFieldRequiredMsg != undefined) {
          this.ownerFieldRequiredMsg.style.color = '';
        }
      }
    }
  }

  onOwnerRemoved(item: any) {
    if (this.ownerFieldRequiredMsg != undefined) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    }
  }
  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  dueDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }
  dueDateOnChanged(items: any) {
    if (items != null || items != undefined) {
      this.dueDateRequiredMsg.style.color = '';
    } else {
      this.dueDateRequiredMsg.style.color = 'red';
    }
  }

  fieldValidation() {

    this.checkRequiredForRequiredMsg = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    this.ownerFieldRequiredMsg = document.getElementById('ownerField-validation') as HTMLInputElement;
    this.dueDateRequiredMsg = document.getElementById('dueDate-validation') as HTMLInputElement;

    if (this.selectedCheckRequiredFor == null) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    } else {
      this.checkRequiredForRequiredMsg.style.color = '';
    }

    if (this.selectedOwner == null) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    } else {
      this.ownerFieldRequiredMsg.style.color = '';
    }

    if (!this.ecData.dueDate == null || this.ecData.dueDate == undefined) {
      this.dueDateRequiredMsg.style.color = 'red';
    } else {
      this.dueDateRequiredMsg.style.color = '';
    }
  }
  snackbarRef: any;
  addFunction(ecData: any) {
    if (this.selectedCheckRequiredFor == null || this.selectedOwner == null || this.ecData.dueDate == null) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
    } else {
      this.isProcessing = true;
      ecData.module = this.qmsservice.moduleName;
      ecData.refNo = this.qmsservice.activityId;
      ecData.remindNDaysBeforeDueDate = this.ecData.remindNDaysBeforeDueDate;
      if (this.selectedCheckRequiredFor != null) {
        ecData.checkReqdFor = this.selectedCheckRequiredFor;
      } else {
        ecData.checkReqdFor = null;
      }
      if (this.selectedOwner != null) {
        ecData.owner = this.selectedOwner;
      } else {
        ecData.owner = null;
      }
      if (this.ecData.dueDate != null) {
        ecData.dueDate = new Date(this.ecData.dueDate);
      } else {
        ecData.dueDate = null;
      }
      this.appService.createQmsTasksEC(this.ecData).subscribe((Response: any) => {
        //this.displayMessage = Response.result;
        //this.displayResultType = Response.resultType;
        if (Response.resultType == 'S') {
          this.visibleAddPopup.close();
          this.openLeftSideGridFunc(this.clickedData);
          this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
            let data: any = [];
            if (res == null) {
              let count = 0;
              data.push("My Tasks(" + count + ")");
            } else {
              data.push("My Tasks(" + res + ")");
            }

            this.dataSource.data = data.map((name: any) => new DynamicFlatNode(name, "", "", "", 0, true));

          })
        }
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        //this.displayMessage = error;
        //this.displaySuccessMessage = false;
        //this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }
  cancelECAddAndEditFunction() {
    this.visibleAddPopup.close();
  }

  onAnswer() {
    this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
      let data: any = [];
      if (res == null) {
        let count = 0;
        data.push("My Tasks(" + count + ")");
      } else {
        data.push("My Tasks(" + res + ")");
      }

      this.dataSource.data = data.map((name: any) => new DynamicFlatNode(name, "", "", "", 0, true));

    })
  }

  onTabChanged($event: any) {
    let data = $event.tab.textLabel;
  }

  displayOrHideTab(tabIndex: number, displayTab: boolean): void {
    const tabHeaders: any = document.getElementById('mat-tab-label-' + this.appService.myTaskCount + '-0') as HTMLInputElement;
    if (tabHeaders != null && tabHeaders != undefined) {
      tabHeaders.style.display = displayTab ? 'inherit' : 'none';
    }
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  fieldsSearchTxt: string = '';
  onFlexifieldSelect(item: any, data: any) {
    item.fieldDefaultValue = data;
    let index = item.dropDownValues.indexOf(data);
    item.fieldScore = item.dropDownValuesForFieldScores[index];
    //this.onFieldFocusout(item);
  }

  checkBoxChecked(data: any, event: any, val: any) {
    if (event.checked) {
      data.checkedCheckBoxValue.push(val);
    } else {
      let index = data.checkedCheckBoxValue.indexOf(val);
      data.checkedCheckBoxValue.splice(index, 1);
    }

  }

  radioBoxChecked(data: any, event: any, val: any) {
    data.fieldDefaultValue = val;
    let index = data.dropDownValues.indexOf(val);
    data.fieldScore = data.dropDownValuesForFieldScores[index];
    //this.onFieldFocusout(data);
  }

  scoreSearchTxt: string = '';
  onScoreBoxChecked(data: any, val: any) {
    data.fieldScore = val;
  }

  isMandatory = false;;
  saveFeedbackFunc() {
    let objectList = [];
    this.isMandatory = false;
    if (this.feedbackData.status === 'Expired') {
      alert('The feedback form is expired');
      return;
    }

    const payload = this.buildAndValidateFeedback();
    if (!payload) {
      alert('Please add all feedback values!');
      return;
    } else {
      for (let i = 0; i < this.feedbackQuestionsList.length; i++) {
        if (this.feedbackQuestionsList[i].fieldTypeCode == "Check Box") {
          this.feedbackQuestionsList[i].fieldDefaultValue = this.feedbackQuestionsList[i].checkedCheckBoxValue.join(",");
        } else if (this.feedbackQuestionsList[i].fieldTypeCode == 'Multiselect Drop Down') {
          this.feedbackQuestionsList[i].fieldDefaultValue = "";
          if (this.feedbackQuestionsList[i].selectedFlexifieldValue.length > 0) {
            for (let p = 0; p < this.feedbackQuestionsList[i].selectedFlexifieldValue.length; p++) {
              this.feedbackQuestionsList[i].fieldDefaultValue += this.feedbackQuestionsList[i].selectedFlexifieldValue;
              this.feedbackQuestionsList[i].fieldDefaultValue += p == this.feedbackQuestionsList[i].selectedFlexifieldValue.length - 1 ? "" : ",";
            }
            // obj.fieldValues=obj.selectedFlexifieldValue[0].valueExp
          }
        }
        this.isProcessing = true;
        let data = {

          feedbackFormId: this.feedbackData.taskNo,
          questionId: this.feedbackQuestionsList[i].questionId,
          fieldValue: this.feedbackQuestionsList[i].fieldDefaultValue,
          fieldScore: this.feedbackQuestionsList[i].fieldScore
        }
        objectList.push(data);
      }

      this.appService.createFeedbackFormUserQuestion(objectList).subscribe((Response: any) => {
        //this.displayMessage = Response.result;
        //this.displayResultType = Response.resultType;
        if (Response.resultType == 'S') {


        }
        this.isProcessing = false;
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });

        this.isProcessing = false;
      }, (error) => {
        //this.displayMessage = error;
        //this.displaySuccessMessage = false;
        //this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  submitFeedbackFunc() {
    if (this.feedbackData.status === 'Expired') {
      alert('The feedback form is expired');
      return;
    }
    let objectList = [];
    this.isMandatory = false;
    const payload = this.buildAndValidateFeedback();
    if (!payload) {
      alert('Please add all feedback values!');
      return;
    } else {
      for (let i = 0; i < this.feedbackQuestionsList.length; i++) {
        if (this.feedbackQuestionsList[i].fieldTypeCode == "Check Box") {
          this.feedbackQuestionsList[i].fieldDefaultValue = this.feedbackQuestionsList[i].checkedCheckBoxValue.join(",");
        } else if (this.feedbackQuestionsList[i].fieldTypeCode == 'Multiselect Drop Down') {
          this.feedbackQuestionsList[i].fieldDefaultValue = "";
          if (this.feedbackQuestionsList[i].selectedFlexifieldValue.length > 0) {
            for (let p = 0; p < this.feedbackQuestionsList[i].selectedFlexifieldValue.length; p++) {
              this.feedbackQuestionsList[i].fieldDefaultValue += this.feedbackQuestionsList[i].selectedFlexifieldValue;
              this.feedbackQuestionsList[i].fieldDefaultValue += p == this.feedbackQuestionsList[i].selectedFlexifieldValue.length - 1 ? "" : ",";
            }
            // obj.fieldValues=obj.selectedFlexifieldValue[0].valueExp
          }
        }
        this.isProcessing = true;
        let data = {

          feedbackFormId: this.feedbackData.taskNo,
          questionId: this.feedbackQuestionsList[i].questionId,
          fieldValue: this.feedbackQuestionsList[i].fieldDefaultValue,
          fieldScore: this.feedbackQuestionsList[i].fieldScore
        }
        objectList.push(data);
      }


      this.appService.createFeedbackFormUserQuestion(objectList).subscribe((Response: any) => {
        //this.displayMessage = Response.result;
        //this.displayResultType = Response.resultType;
        if (Response.resultType == 'S') {
          this.isProcessing = true;
          let data = {

            feedbackFormUserId: this.feedbackData.taskNo

          }
          this.appService.submitFeedbackResponse(data).subscribe((Response1: any) => {
            //this.displayMessage = Response.result;
            //this.displayResultType = Response.resultType;
            if (Response1.resultType == 'S') {
              this.visibleFeedbackPopup.close();
              this.openLeftSideGridFunc(this.clickedData);
            }


            this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response1.result,
                type: Response1.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response1.resultType == 'S' ? 'Success' : 'Error',
            });
            this.snackbarRef.onAction().subscribe(() => {
              this.snackbarRef.dismiss();
            });


            this.isProcessing = false;
          }, (error) => {
            //this.displayMessage = error;
            //this.displaySuccessMessage = false;
            //this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          });

        }
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });

        this.isProcessing = false;
      }, (error) => {
        //this.displayMessage = error;
        //this.displaySuccessMessage = false;
        //this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }

  }

  private buildAndValidateFeedback(): any[] | null {
    const objectList: any[] = [];

    for (const field of this.feedbackQuestionsList) {

      let fieldValue: string | null = null;

      switch (field.fieldTypeCode) {

        case 'Text Field':
        case 'Large Text Field':
        case 'Date Field':
        case 'Radio Button':
        case 'Drop Down':
          fieldValue = field.fieldDefaultValue?.toString().trim() || null;
          break;

        case 'Check Box':
          fieldValue = field.checkedCheckBoxValue?.length
            ? field.checkedCheckBoxValue.join(',')
            : null;
          break;

        case 'Multiselect Drop Down':
          fieldValue = field.selectedFlexifieldValue?.length
            ? field.selectedFlexifieldValue.join(',')
            : null;
          break;
      }

      // 🔴 Mandatory validation AFTER normalization
      if (!fieldValue) {
        return null;
      }

      objectList.push({
        feedbackFormId: this.feedbackData.taskNo,
        userId: this.message.getUserId(),
        questionId: field.questionId,
        fieldValue,
        fieldScore: field.fieldScore
      });
    }

    return objectList;
  }

  cancelFeedbackFunc() {
    this.visibleFeedbackPopup.close();
  }

  onQuesAndAnswSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
      }
    }

  }
  @ViewChild('flexifieldValueSelected1') flexifieldValueSelected1: MatSelect;
  flexifieldValueSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'flexifieldValueSelected') {
      if (this.flexifieldValueSelected) {
        this.flexifieldValueSelected1.options.forEach((item: MatOption) => item.select());
      } else {
        this.flexifieldValueSelected1.options.forEach((item: MatOption) => item.deselect());
      }
    }

  }

  flexifieldValueTxt: string = '';
  onFieldFocusout(field: any) {

  }


  //multi select
  bulkorsingle = "";
  multiArray: any = [];
  searchParentCheckBox: boolean = false;
  selectAll(e: any) {

    if (e.target.checked) {
      this.multiArray = [];
      this.taskDetailList.forEach((templates: any) => {
        if (templates.taskName) {
          templates.searchChildCheckBox = true; // Updated property
          this.multiArray.push({ taskNo: templates.taskNo, taskName: templates.taskName, status: templates.status });
        }
      });
      this.searchParentCheckBox = true;
    } else {
      this.multiArray = [];
      this.taskDetailList.forEach((template: any) => {
        if (template.taskName) {
          template.searchChildCheckBox = false; // Updated property
        }
      });
      this.searchParentCheckBox = false;
    }
  }
  onChildCheckBoxChanged(e: any, listOfTemplateData: any, idx: any) {
    if (e.target.checked) {
      listOfTemplateData.searchChildCheckBox = true;
      if (!this.multiArray.some((storedTemplate: any) => storedTemplate.taskNo === listOfTemplateData.taskNo)) {
        this.multiArray.push({
          taskNo: listOfTemplateData.taskNo,
          taskName: listOfTemplateData.taskName,
          status: listOfTemplateData.status
        });
      }

      const allSelected = this.taskDetailList.every((item: any) => item.searchChildCheckBox);
      this.searchParentCheckBox = allSelected;

    } else {
      listOfTemplateData.searchChildCheckBox = false;
      const removal = this.multiArray.findIndex((removableTemplate: any) => removableTemplate.taskNo == listOfTemplateData.taskNo);
      if (removal > -1) {
        this.multiArray.splice(removal, 1);
      }
      this.searchParentCheckBox = false;
    }
    console.log("Selected Items:", this.multiArray.length);
  }
  unlockTrainings() {
    this.bulkorsingle = 'bulk';
    console.log("=====", this.multiArray.length)
    if (this.multiArray.length > 50) {
      alert("You cannot select more than 50 trainings.");
    } else {
      this.dueDate = null;
      this.title = this.multiArray[0].status;

      if (this.multiArray[0].status == "Locked Overdue(RM Approved)" || this.multiArray[0].status == "Locked Overdue") {
        this.isShowDueDate = true;
      } else {
        this.isShowDueDate = false;
      }
      // })



      this.password = "";
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    }
  }
  responses: any[] = [];
  popupTitle: string | null = 'title';
  dued: any;
  dueDateMsg: any;
  unlockTranningBulk() {
    this.responses = [];
    if (this.isShowDueDate && this.dueDate == null) {
      this.isProcessing = false;
      this.dued = document.getElementById('dued') as HTMLInputElement;
      this.dueDateMsg = document.getElementById('due-required-msg') as HTMLInputElement;
      if (this.dueDate == "" || this.dueDate == null) {
        this.dued.style.border = '1px solid red';
        this.dueDateMsg.style.display = 'block';
      } else {
        this.dued.style.border = 'none';
        this.dueDateMsg.style.display = 'none';
      }


    } else {
      for (let i = 0; i < this.multiArray.length; i++) {
        this.appService
          .getUserTrainingsByTrainingId(
            this.multiArray[i].taskNo
          )
          .subscribe((tdata: any) => {
            const trainingData = tdata[0]; // scoped variable (not shared)

            let data1 = {
              userTrainingId: trainingData.userTrainingId,
              dueDate: this.appService.dateZoneConvertion(new Date(this.dueDate)),
            };

            this.isProcessing = true;
            this.appService.unlockTraining(data1).subscribe(
              (data: any) => {


                if (data.resultType == "S") {
                  console.log(trainingData.userTrainingId, trainingData.userName);
                  this.responses.push({
                    userTrainingName: trainingData.trainingName,
                    userName: trainingData.userName,
                    response: data,
                  });
                } else {
                  this.responses.push({
                    userTrainingName: trainingData.trainingName,
                    userName: trainingData.userName,
                    response: data,
                  });
                }

                if (i == this.multiArray.length - 1) {

                  this.visibleConfirmWithReason.close();
                  setTimeout(() => {
                    this.popupTitle = "Unlock Trainings";

                    this.visibleResultPopup = this.dialog.open(
                      this.resultPopup,
                      this.resultPopupConfig
                    );
                    this.isProcessing = false;
                  }, 5000);
                }
              },
              (error) => {
                this.isProcessing = false;
                throw error;
              }
            );
          });
      }
    }


  }


  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;
  resultPopupConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  cancelResultPopup() {
    this.visibleResultPopup.close();
    this.openLeftSideGridFunc(this.clickedData);

    this.appService.getRootNodes(this.appService.getRouteOfMyTask()).subscribe((res: any) => {
      if (res != null) {
        this.totalCount = res;
      }
    });

    this.isProcessing = true;
    this.appService.getSubNodesForMyTask(
      "My Tasks",
      this.appService.getRouteOfMyTask()
    ).subscribe((data: any) => {
      this.isProcessing = false;

      if (!data) {
        return;
      }

      this.dataSource.data = data.map((obj: any) =>
        new DynamicFlatNode(
          obj.status + "(" + obj.cnt + ")",
          "My Tasks",
          obj.moduleName,
          obj.moduleCode,
          1,
          obj.expandable
        )
      );
    });
  }

  public readonly commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
  }

  @ViewChild('userPopup', { static: true }) userPopup: TemplateRef<any>;
  private visibleUserPopup: MatDialogRef<TemplateRef<any>>;

  private readonly userPopupConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  user: any = {};
  public openUserPopup(data: any, event: any): void {
    event.preventDefault();
    this.isProcessing = true;
    this.appService.getUserDetailsForTrainingDashboard(+data.taskNo!).subscribe((user: any) => {
      this.user = user[0];
      this.user.isActive = this.user.isActive == 'Y';
      this.user.isAdUser = this.user.isAdUser == 'Y';
      this.user.isUserDeactivated = this.user.isUserDeactivated == 'Y';
      this.user.joiningDate = this.user.joiningDate ? new Date(this.user.joiningDate) : null;
      this.user.relievingDate = this.user.relievingDate ? new Date(this.user.relievingDate) : null;
      this.getUserDynamicLabel();
    })
  }

  dynamicLabel: any = null;
  private getUserDynamicLabel(): void {
    this.isProcessing = true;
    const data = {
      tableName: 'ONEQMS_USERS_VW',
      moduleName: null,
      gridName: 'USERS',
      groupId: 0
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        const label: [] = response;
        this.dynamicLabel = label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
        this.visibleUserPopup = this.dialog.open(this.userPopup, this.userPopupConfig);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw new Error(error);
      }
    });
  }

  public closeUserPopup(): void {
    this.refreshGrid();
    this.visibleUserPopup.close();
  }

  private refreshGrid(): void {
    this.isProcessing = true;
    this.appService.getTaskDetail(this.copyObjToRefreshGrid).subscribe((data: any) => {
      this.isProcessing = false;
      this.multiArray = [];
      this.taskDetailList = data;
      this.collectionSize = this.taskDetailList.length;
      this.setPage(1, 0);
      this.isShowInfoGrid = true;
    })
  }

  deactivationDecision: string = '';
  public verifyUser(flag: string): void {
    this.comments = '';
    this.password = '';
    this.isEsignRequired = true;
    console.log('l');
    this.deactivationDecision = flag;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  public deactivateUser(): void {

    const keysToRemove = new Set([
      'badgeName', 'count', 'countryName', 'createdBy', 'createdByUser',
      'createdOn', 'createdOnStr', 'department', 'designation', 'isFactoryUser',
      'isLocked', 'lastLogonDate', 'lastLogonDateStr', 'lastUserAccessedOn',
      'lastUserAccessedOnStr', 'managerName', 'passwordResetDate', 'passwordResetDateStr',
      'sessionUserId', 'deactivationApprovalRequestedBy', 'deactivationApprovalRequestedOn',
      'deactivationApprovalRequestedOnStr', 'deactivationApprovedBy', 'deactivationApprovedOn',
      'deactivationApprovedOnStr', 'tokenId', 'trainingCount', 'trainingsList',
      'updatedBy', 'updatedByUser', 'updatedOn', 'updatedOnStr', 'userFullName',
      'userNameAtApplication', 'userNameAtReports', 'wherVal', 'wrongLoginAttempts'
    ]);

    const obj = Object.fromEntries(Object.entries(this.user).filter(([key]) => !keysToRemove.has(key)));
    const activeValue: string = this.user.isActive ? 'Y' : 'N';

    obj['joiningDate'] = this.formatDate$(this.user.joiningDate);
    obj['relievingDate'] = this.formatDate$(this.user.relievingDate);
    obj['isActive'] = this.user.isActive ? 'Y' : 'N';
    obj['isAdUser'] = this.user.isAdUser ? 'Y' : 'N';
    obj['isUserDeactivated'] = this.deactivationDecision == 'approve' ? 'Y' : 'N';
    obj['userStatus'] = this.deactivationDecision == 'approve' ? 'User Deactivated' : 'User Deactivation Rejected';
    obj['relievingDate'] = this.deactivationDecision == 'approve' ? obj['relievingDate'] : null;
    obj['updateReason'] = this.comments;

    this.isProcessing = true;
    this.appService.updateOneQmsUsers(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.refreshGrid();
          this.visibleDeletePopup.close();
          this.visibleUserPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private formatDate$(date: any): string | null {
    if (!date) return null;
    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) return null; // Invalid date safety
    return parsed.toISOString(); // e.g. "2025-10-07T09:36:51.000Z"
  }

  private showSnackBar(message: string, type: string): void {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  public getCLOB(heading: any, value: any): void {
    this.editorComponent.openEditor(value, heading);
  }
  //Date Convertion
  dateZoneConvertion(date: any) {
    let spliteddata = date.toString().split(" ");
    for (let j = 0; j < spliteddata.length; j++) {
      if (spliteddata[j].includes("GMT")) {
        let splitedGMTData = spliteddata[j].split("GMT");
        if (splitedGMTData[1].includes("+")) {
          let zone = splitedGMTData[1].slice(1);
          let hs: any = zone[0] + "" + zone[1];
          let ms: any = +zone[2] + "" + zone[3];
          console.log(hs, ms);
          date.setHours(12 + +hs);
          date.setMinutes(+ms);
          date.setSeconds(0);
          console.log(date);
        } else {
          if (splitedGMTData[1].includes("-")) {
            let zone = splitedGMTData[1].slice(1);
            let hs: any = zone[0] + "" + zone[1];
            let ms: any = +zone[2] + "" + zone[3];
            console.log(hs, ms);
            date.setHours(12 - +hs);
            date.setMinutes(+ms);
            date.setSeconds(0);
            console.log(date);
          }
        }

      }
    }
    return date;
  }

  public getOwnerTitle(clickedData: any): string {
    if (clickedData.title == 'Change Request' || clickedData.title == 'CAPA' || clickedData.title == 'Deviation' || clickedData.title == 'OOS' || clickedData.title == 'E-Sign') {
      return 'Owner';
    } else if (clickedData.title == 'Customer Complaint' || clickedData.title == 'Quality Issue' || clickedData.title == 'Incident') {
      return 'Evaluator';
    } else if (clickedData.title == 'Audit') {
      return 'Lead Auditor';
    } else {
      return clickedData.title;
    }
  }
}
